module.exports = __webpack_public_path__ + "778579c515f734d57244ab432b9c58f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-7.png
// module id = 2300
// module chunks = 0